import useNavigationStore from '@src/stores/navigationStore';
import useRegistrationStore from '@src/stores/registrationStore';

import styles from './Beneficiaries.module.scss';

import BlockTitle from '@src/components/_shared/UI/BlockTitle';
import BackButton from '@src/components/_shared/BackButton';
import Container from '@src/components/_shared/Container';
import Subtitle from '@src/components/_shared/UI/Subtitle';
import ValidateChoiceButton from '@src/components/_shared/UI/ValidateChoiceButton';
import { useState } from 'react';
import Input from '@src/components/_shared/UI/Input';
import { Form, Formik } from 'formik';
import ValidateButton from '@src/components/_shared/UI/ValidateButton';
import DropdownList from '@src/components/_shared/UI/DropdownList';


export default function Beneficiaries() {
    const { setSection, setBlock } = useNavigationStore();
    const { setField, registration } = useRegistrationStore();
    const [othersBeneficiaries, setOthersBeneficiaries] = useState<boolean>(false);

    const _onGoBack = () => {
        setSection(3)
        setBlock('Various')
    };

    if (othersBeneficiaries) {
        const title = registration.company.beneficial_owners[0].data.is_beneficial_owner ? 'Autres bénéficiaires effectifs' : 'Bénéficiaires effectifs';
        const subtitle = registration.company.beneficial_owners[0].data.is_beneficial_owner ? 'La société a-t-elle d’autres bénéficiaires effectifs' : 'La société a-t-elle des bénéficiaires effectifs';
        return (
            <Container>
                <BackButton onClick={() => setOthersBeneficiaries(false)}/>
                <BlockTitle title={title} />
                <Subtitle content={subtitle} />
                <Formik
                    initialValues={{
                        hasOtherBeneficiary: registration.company.beneficial_owners.length > 1 || null,
                        othersBeneficiariesNumber: registration.company.beneficial_owners.length - 1 || null
                    }}
                    onSubmit={(values: any) => {
                        const currentBeneficiaries = registration.company.beneficial_owners || [];
                        const firstBeneficiary = currentBeneficiaries[0];
                        const totalBeneficiaries = Number(values.othersBeneficiariesNumber) + 1;
                        const updatedBeneficiaries = [
                            firstBeneficiary,
                            ...Array.from({ length: totalBeneficiaries - 1 }, (_, index) => {
                                if (currentBeneficiaries[index + 1]) {
                                    return currentBeneficiaries[index + 1];
                                }
                                return {
                                    data: {
                                        is_beneficial_owner: true,
                                        shareholding: '',
                                        person: {
                                            civility: '',
                                            firstname: '',
                                            lastname: '',
                                            birthname: '',
                                            residence_country: '',
                                            birthdate: '',
                                            address: {
                                                street_name: '',
                                                city: {
                                                    zipcode: '',
                                                    name: ''
                                                },
                                                country: ''
                                            },
                                            phone: '',
                                            email: ''
                                        }
                                    }
                                };
                            })
                        ];
                        setField('company.beneficial_owners', updatedBeneficiaries);
                        if (values.hasOtherBeneficiary || registration.company.beneficial_owners[0].data.is_beneficial_owner) {
                            setBlock('BeneficiariesInformations');
                        } else {
                            setSection(4);
                            setBlock('LCBFT');
                            setOthersBeneficiaries(false);
                        }
                    }}
                    enableReinitialize={true}
                >
                    {({ handleChange, handleSubmit, values, setFieldValue }: any) => {
                        return(
                            <Form id="othersBeneficiariesNumber" className="registerForm" autoComplete="off" style={{ width: '100%' }}>
                                <div className={styles.buttons}>
                                    <ValidateChoiceButton selected={values.hasOtherBeneficiary === true} title="Oui" onValidate={() => setFieldValue('hasOtherBeneficiary', true)} />
                                    <ValidateChoiceButton
                                        selected={values.hasOtherBeneficiary === false}
                                        title="Non"
                                        onValidate={() => {
                                            setFieldValue('hasOtherBeneficiary', false);
                                            setFieldValue('othersBeneficiariesNumber', '0');
                                            setField('company.beneficial_owners', registration.company.beneficial_owners.slice(0, 1));
                                            handleSubmit();
                                        }}
                                    />
                                </div>
                                {values.hasOtherBeneficiary === true ?
                                    <>
                                        <div style={{ width: '100%' }}>
                                            <DropdownList
                                                title={`Nombre de bénéficiaires ${registration.company.beneficial_owners[0].data.is_beneficial_owner ? " supplémentaires" : ""}`}
                                                width="100%"
                                                options={{
                                                    1: '1',
                                                    2: '2',
                                                    3: '3',
                                                    4: '4'}}
                                                selected={values.othersBeneficiariesNumber || registration.company.beneficial_owners.filter(beneficiary => !beneficiary.data.is_legal_representative).length}
                                                onSelect={handleChange('othersBeneficiariesNumber')} />
                                        </div>
                                        <ValidateButton disabled={!values.othersBeneficiariesNumber} title="Continuer" onClick={handleSubmit} />
                                    </>
                                    : null}
                            </Form>
                        )
                    }}
                </Formik>
            </Container>
        )
    }

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Statut du représentant légal au sein de la société" />
            <Subtitle content="En tant que représentant légal de la société, êtes-vous bénéficiaire effectif ?" />
            <Formik
                initialValues={{
                    isOwner: registration.company.beneficial_owners[0]?.data?.is_beneficial_owner || null,
                    ownershipPercent: registration.company.beneficial_owners[0]?.data?.shareholding || ''
                }}
                onSubmit={(values: any) => {
                    const formattedOwnershipPercent = values.ownershipPercent 
                        ? values.ownershipPercent.toString().replace(',', '.') 
                        : values.ownershipPercent;

                    setField(`company.beneficial_owners.0.data`, {
                        ...registration.company.beneficial_owners[0]?.data,
                        is_legal_representative: true,
                        is_beneficial_owner: values.isOwner,
                        shareholding: formattedOwnershipPercent,
                        person: {
                            civility: registration.person.basic.civility,
                            firstname: registration.person.basic.firstname,
                            lastname: registration.person.basic.lastname,
                            birthname: registration.person.basic.birthname,
                            residence_country: registration.person.basic.residence_country,
                            birthdate: registration.person.birth.date,
                            address: {
                                ...(registration.addresses[0].street_number && ({street_number: registration.addresses[0].street_number})),
                                ...(registration.addresses[0].street_extension && ({street_extension: registration.addresses[0].street_extension})),
                                street_name: registration.addresses[0].street_name,
                                ...(registration.addresses[0].street_name_further && ({street_name_further: registration.addresses[0].street_name_further})),
                                city: {
                                    zipcode: registration.addresses[0].city.zipcode,
                                    name: registration.addresses[0].city.name
                                },
                                country: registration.addresses[0].country
                            },
                            phone: registration.person.basic.phone,
                            email: registration.person.basic.email
                        }
                    })
                    setOthersBeneficiaries(true);
                }}
            >
                {({ handleChange, handleSubmit, values, setFieldValue }: any) => {
                    return(
                        <Form id="ownershipPercentage" className="registerForm" autoComplete="off" style={{ width: '100%' }}>
                            <div className={styles.buttons}>
                                <ValidateChoiceButton selected={values.isOwner === true} title="Oui" onValidate={() => setFieldValue('isOwner', true)} />
                                <ValidateChoiceButton
                                    selected={values.isOwner === false}
                                    title="Non"
                                    onValidate={() => {
                                        setFieldValue('isOwner', false);
                                        setFieldValue('ownershipPercent', '0');
                                        handleSubmit();
                                    }}
                                />
                            </div>
                            {values.isOwner === true ?
                                <div style={{ width: "460px" }}>
                                    <Input
                                        title="Votre pourcentage de détention du capital de la société"
                                        name="ownershipPercent"
                                        id="ownershipPercent"
                                        width="100%"
                                        placeholder="Ex : 50"
                                        type="number"
                                        value={values.ownershipPercent}
                                        onChange={handleChange('ownershipPercent')}
                                        clearInput={() => handleChange('ownershipPercent')('')}
                                    />
                                    <ValidateButton disabled={values.ownershipPercent === ''} title="Continuer" onClick={handleSubmit} />
                                </div>
                                : null}
                        </Form>
                    )
                }}
            </Formik>
        </Container>
    );
}
